'use strict';

const $ = jQuery.noConflict();
$(function() {

	const postSingle = {

		init: function() {
			this.cacheDOM();
			this.bindEvents();
			this.initPosters();
			this.initTables();
		},

		cacheDOM: function() {
			this.$body = $('.js-post-body');
			this.$tables = this.$body.find('.post-table--scroll');
		},

		bindEvents: function() {
			this.$body.on('click', '.js-post-video .post-video__play', this.onVideoPlay.bind(this));
			$(window).on('resize', this.updateTables.bind(this));
		},

		// load the video (with autoplay) in place of the poster
		onVideoPlay: function(e) {
			const $video = $(e.currentTarget).closest('.js-post-video');
			const embed = $video.attr('data-embed');
			if (!embed) {
				return;
			}
			$video.empty().append($.parseHTML(embed));
			$video.find('iframe').trigger('focus');
		},

		// the biggest YouTube poster does not exist for every video, use the smaller one then
		initPosters: function() {
			this.$body.find('.js-post-video-poster').each((index, img) => {
				const fallback = img.getAttribute('data-fallback');
				if (!fallback || fallback === img.getAttribute('src')) {
					return;
				}
				const useFallback = () => {
					img.setAttribute('src', fallback);
				};
				img.addEventListener('error', useFallback, {once: true});
				// YouTube answers with a tiny placeholder image when the poster is missing
				img.addEventListener('load', () => {
					if (img.naturalWidth <= 120) {
						useFallback();
					}
				}, {once: true});
				if (img.complete && img.naturalWidth > 0 && img.naturalWidth <= 120) {
					useFallback();
				}
			});
		},

		// fade edges of the wide tables which scroll horizontally
		initTables: function() {
			this.$tables.each((index, table) => {
				$(table).find('.js-post-table-scroll').on('scroll', () => this.updateTable($(table)));
				this.updateTable($(table));
			});
		},

		updateTables: function() {
			this.$tables.each((index, table) => this.updateTable($(table)));
		},

		updateTable: function($table) {
			const scroller = $table.find('.js-post-table-scroll')[0];
			if (!scroller) {
				return;
			}
			const maxScroll = scroller.scrollWidth - scroller.clientWidth;
			$table.toggleClass('is-scrolled', scroller.scrollLeft > 2);
			$table.toggleClass('is-scroll-end', maxScroll <= 2 || scroller.scrollLeft >= maxScroll - 2);
		},
	};

	postSingle.init();
});
